function createThumbnail(img) {
  const thumb = img.cloneNode();
  thumb.className = "";
  return thumb;
}

function createSlide(img, caption) {
  const slide = document.createElement("div");
  slide.classList.add("swiper-slide");

  const imgWrapper = document.createElement("div");
  imgWrapper.classList.add("img-wrapper");
  imgWrapper.append(img);

  slide.append(imgWrapper);

  if (caption != null && caption.length > 0) {
    const span = document.createElement("span");
    span.textContent = caption;
    slide.append(span);
  }

  return slide;
}

class ImageGallery extends HTMLElement {
  _activeIdx = 0;
  status = "closed";

  constructor() {
    super();
  }

  connectedCallback() {
    const dataSourceSelector = this.getAttribute("data-source-selector");
    if (dataSourceSelector == null) {
      console.warn("[image-gallery] No data source selector found");
    }

    const dataSource = document.querySelector(dataSourceSelector);
    const dataSourceItems = dataSource.querySelectorAll(".data-source-item");

    if (dataSourceItems == null) {
      console.warn("[image-gallery] No image gallery data sources found");
    }

    this.innerHTML = `
        <header>
            <button>✕</button>
        </header>
        <div class="image-gallery__main swiper" style="--swiper-navigation-color: #fff;">
            <div class="swiper-wrapper">
            </div>
            <div class="btn-container prev">
                <button class="swiper-button-prev"></button>
            </div>
            <div class="btn-container next">
                <button class="swiper-button-next"></button>
            </div>
        </div>
        <footer></footer>
    `;

    this.swiperWrapper = this.querySelector(".swiper-wrapper");
    this.footer = this.querySelector("footer");

    let idx = 0;
    for (const item of dataSourceItems) {
      const img = item.querySelector("img");
      img.classList.add("swiper-slide");
      const caption = item.querySelector(`[data-component="caption"]`)?.dataset
        .value;

      const slide = createSlide(img, caption);
      this.swiperWrapper.appendChild(slide);

      const thumb = createThumbnail(img);
      if (idx == 0) {
        thumb.setAttribute("data-active", true);
      }
      thumb.setAttribute("data-idx", idx);
      thumb.classList.add("thumbnail");
      thumb.addEventListener("click", () => {
        this.handleClickThumbnail(thumb);
      });

      this.footer.appendChild(thumb);

      ++idx;
    }

    const prevBtn = this.querySelector(".btn-container.prev button");
    const nextBtn = this.querySelector(".btn-container.next button");

    prevBtn.addEventListener("click", () => {
      this.handleClickPrev();
    });
    nextBtn.addEventListener("click", () => {
      this.handleClickNext();
    });

    const closeButton = this.querySelector("header button");
    closeButton.addEventListener("click", () => {
      this.handleClickClose();
    });

    const swiperEl = this.querySelector(".swiper");
    this.swiper = new Swiper(swiperEl, {
      speed: 300,
      spaceBetween: 100,
      loop: true,
    });

    this.swiper.on("slideChange", ({ realIndex }) => {
      this.activeIdx = realIndex;
    });

    this.setAttribute("data-status", "closed");
  }

  handleClickClose() {
    this.setStatus("closed");
  }

  handleClickPrev() {
    this.swiper.slidePrev();
  }

  handleClickNext() {
    this.swiper.slideNext();
  }

  handleClickThumbnail(thumbnail) {
    const idxAttr = thumbnail.getAttribute("data-idx");
    const idx = Number(idxAttr);
    if (idxAttr == null || Number.isNaN(idx)) {
      console.error(
        "[image-gallery] Unable to find index for selected thumbnail",
      );
      return;
    }

    this.activeIdx = idx;
    this.slideTo(idx, true, false);
  }

  updateThumbnail() {
    let selected;

    this.thumbnails.forEach((t, idx) => {
      if (idx == this.activeIdx) {
        selected = t;
        t.setAttribute("data-active", true);
        return;
      }
      t.setAttribute("data-active", false);
    });

    let behavior = "auto";
    if (this.status === "open") {
      behavior = "smooth";
    }

    if (selected == null) {
      console.error("[image-gallery] Unable to find selected thumbnail");
      return;
    }

    selected.scrollIntoView({
      behavior,
      inline: "center",
    });
  }

  slideTo(idx, animate, runCallbacks) {
    this.swiper.slideToLoop(idx, animate ? 300 : 0, runCallbacks);
  }

  set activeIdx(idx) {
    if (idx == this._activeIdx) {
      return;
    }
    this._activeIdx = idx;

    // Side effects
    this.slideTo(idx, false, true);
    this.updateThumbnail();
  }

  get activeIdx() {
    return this._activeIdx;
  }

  get thumbnails() {
    return this.querySelectorAll("footer .thumbnail");
  }

  /**
   * Public methods
   * */

  setStatus(status) {
    this.status = status;
    if (!["open", "closed"].includes(status)) {
      console.error("[image-gallery] Invalid status: ${status}");
      return;
    }
    this.setAttribute("data-status", status);
  }

  openAtIdx(idx) {
    this.activeIdx = idx;
    this.setStatus("open");
  }
}

if (customElements.get("image-gallery") == null) {
  customElements.define("image-gallery", ImageGallery);
}
